module.exports = __webpack_public_path__ + "static/media/gallerryimg3.73f452b3.JPG";